// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_zbzEx","foot_link":"index_foot_link_fBREF","list":"index_list_EA--R","link":"index_link_Z7IcV","copyright":"index_copyright_e-SKX"};